export class SplApprovalRequestDto 
{
  id: number = 0;
  delegateId: number = 0;  
  relatedTo: string | null = null;
  splName: string | null = null;
  type: string | null = null;
  recentApprover: string | null = null;
  dateSubmitted?: Date | null = null;
}